module.exports = "/*\nTo change this license header, choose License Headers in Project Properties.\nTo change this template file, choose Tools | Templates\nand open the template in the editor.\n*/\n/* \n    Created on : 22.03.2017, 15:21:02\n    Author     : cost\n*/\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/impressum/impressum.component.css
// module id = ./src/app/impressum/impressum.component.css
// module chunks = 0